"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Module = require("../Module");

var _ = require("../");

var _functions = require("../../resources/functions/");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class AnalyticsTableBodyRow extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getClassName", () => {
      return "admin-analytics-table__row";
    });

    _defineProperty(this, "renderDimensions", () => {
      const _this$props = this.props,
            dimensions = _this$props.dimensions,
            thStyle = _this$props.thStyle,
            urlPattern = _this$props.urlPattern;
      let metadata = [];

      if (dimensions.length >= 2) {
        metadata = dimensions.slice(1, dimensions.length);
      }

      const url = (0, _functions.getUrlFromProps)(this.props, urlPattern);

      if (url) {
        metadata.push(url);
      }

      const title = dimensions[0];
      const description = metadata.join('–');
      return _react.default.createElement("th", {
        style: thStyle
      }, _react.default.createElement(_Module.ModuleLink, {
        url: url
      }, _react.default.createElement(_Module.ModuleTitle, {
        title: dimensions[0]
      }), _react.default.createElement(_Module.ModuleMetadata, {
        metadata: metadata
      })));
      return _react.default.createElement("th", {
        style: thStyle
      }, title, description);
    });

    _defineProperty(this, "renderMetricValue", (metric, index) => {
      const _this$props2 = this.props,
            metrics = _this$props2.metrics,
            totals = _this$props2.totals,
            sortBy = _this$props2.sortBy,
            tdStyle = _this$props2.tdStyle;
      const name = metric.name,
            type = metric.type;
      const value = metrics[0].values[index];
      let selected;

      if (sortBy === name) {
        selected = true;
      }

      const pctOfTotal = value / totals[index] * 100;
      return _react.default.createElement("td", {
        style: tdStyle,
        key: index,
        "aria-selected": selected
      }, _react.default.createElement("b", null, _react.default.createElement(_.FormatMetric, _extends({}, metric, {
        value: value
      }))), _react.default.createElement("i", null, _react.default.createElement(_.FormatMetric, {
        type: "PERCENT",
        value: pctOfTotal
      })));
    });

    _defineProperty(this, "renderMetrics", () => {
      const metricHeaders = this.props.metricHeaders;
      return metricHeaders.map(this.renderMetricValue);
    });
  }

  render() {
    const className = this.getClassName();
    return _react.default.createElement("tr", {
      className: className
    }, this.renderDimensions(), this.renderMetrics());
  }

}

_defineProperty(AnalyticsTableBodyRow, "defaultProps", {
  dimensions: [],
  metrics: [],
  urlPattern: undefined
});

var _default = AnalyticsTableBodyRow;
exports.default = _default;
module.exports = exports.default;